import  Axios from "axios";
import router from "../router/index.js";

export default function setaAxios() {
	const usuario = JSON.parse(localStorage.getItem("usuario"));

	Axios.defaults.headers.common.Authorization = usuario == null ? "" : `Bearer ${usuario.token}`;

	Axios.interceptors.response.use(response => Promise.resolve(response)
		, (error) => {
			if (error.response) {
				if (error.response.status == 401 || error.response.status == 403) {
					localStorage.clear();
					router.push("/login");
					Axios.defaults.headers.common.Authorization = "";
				}
			}
			return Promise.reject(error);
		});
}



// WEBPACK FOOTER //
// ./src/service/Axios.js